// extracted by mini-css-extract-plugin
export default {"page-container":"qfwufv","page-container--side-nav-collapsed":"KpKjB0"};